import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { isLotteryType } from '../../../utils/LotteryHelpers';
import { FEWER_LINES_SIGNAL, MORE_LINES_SIGNAL } from '../Types/Constants';
import { RootState } from '../redux/store';
import { clickLinesManageButton } from '../redux/storeSlice';

export default function PurchaseMoreLessButtons({ className = '' }: Readonly<{ className?: string }>) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { lines, lottery, isMobile } = useSelector((state: RootState) => state.playStore);
    const { desktopRowSize } = useSelector((state: RootState) => state.lotteryPlayStore);
    const moreDisabled = lines.length >= lottery.maxLinesPerTicket;
    const fewerDisabled = lines.length <= (!isMobile && isLotteryType(lottery.type) ? desktopRowSize : 1);

    return (
        <div className={`purchase-more-less-wrapper ${className}`}>
            <button
                type="button"
                onClick={() => dispatch(clickLinesManageButton(MORE_LINES_SIGNAL))}
                className={`btn btn-secondary purchase-more mr-2 ${moreDisabled ? 'disabled' : ''}`}
            >
                {t('playPicker.addMoreLines')}
            </button>
            <button
                type="button"
                onClick={() => dispatch(clickLinesManageButton(FEWER_LINES_SIGNAL))}
                className={`btn btn-secondary purchase-less ml-1 ${fewerDisabled ? 'disabled' : ''}`}
            >
                {t('playPicker.fewerLines')}
            </button>
        </div>
    );
}
